import { lazy, Suspense } from "react";
import { Property } from "csstype";
import { LazyLoadingAnimation } from "./Lazy";
import type { LocalizationMap } from "./Localization/Localization";

const ImageViewerBase = lazy(() => import("./ImageViewerAsync"));
// ================================================================================================
export interface ImageViewerCropperData {
    img: string;
    Data: Cropper.Data;
    CropBoxData: Cropper.CropBoxData;
    CanvasData: Cropper.CanvasData;
    ZoomRatio: number;
}
export interface ImageViewerProps {
    key?: string;
    /**
     * Component's available width
     */
    width: number;

    /**
     * Component's available height
     */
    height: number;

    /**
     * Image URI
     */
    img: string;

    /**
     * If enabled, plain image will be drawn. No toolbar will be shown.
     * More specifically, all widget's size will be used and the image will be centered with aspect ratio mantained.
     */
    singleView: boolean;

    /**
     * The obgject-fit propery of an image.
     */

    objectFit: Property.ObjectFit;

    /**
     * Whether to show toolbar or not.
     */
    showToolbar: boolean

    /**
     * Whether to support crop or not.
     */
    supportCrop: boolean
    onSelectedImagePart?: (base64Url: string) => void;

    /**
     * Whether to support rotation or not.
     */
    supportRotate: boolean;

    /**
     * Whether to support mouse drag or not.
     */
    supportMouseMove: boolean;

    /**
     * callback triggered on data change
     */
    onCropperDataChange?: (data: ImageViewerCropperData) => void;

    /**
     * initial cropper's data
     */
    cropperData?: ImageViewerCropperData;

    /**
     * Optional key for applying localization.
     */
    localizationKey?: string;
}
// ================================================================================================
export const enum ImageViewerUILabelKey {
    FitBounds = "fit-bounds",
    SupportMouseMove = "mode-move",
    SupportCrop = "mode-crop",
    SelectImage = "send-image",
    Clear = "clear",
    Rotate90 = "rotate-90",
    RotateMinus90 = "rotate-minus-90",
}
// ------------------------------------------------------------------------
export class ImageViewerStatics {
    // ------------------------------------------------------ +++ Localization
    public static LocalizationTextMapKey: string = "Primitive_ImageViewer";
    // ------------------------------------------------------ 
    public static GetLocalizationDictionary(): LocalizationMap {
        return {
            [ImageViewerUILabelKey.FitBounds]: "Fit bounds",
            [ImageViewerUILabelKey.SupportMouseMove]: "Move",
            [ImageViewerUILabelKey.SupportCrop]: "Crop",
            [ImageViewerUILabelKey.SelectImage]: "Select Image",
            [ImageViewerUILabelKey.Clear]: "Clear",
            [ImageViewerUILabelKey.Rotate90]: "Rotate 90 degrees",
            [ImageViewerUILabelKey.RotateMinus90]: "Rotate -90 degrees",
        };
    }

}
// ================================================================================================
export var ImageViewer = (props: ImageViewerProps) => {
    return (
        <Suspense fallback={<LazyLoadingAnimation />}>
            <ImageViewerBase {...props} />
        </Suspense>
    );
}
// ================================================================================================